/** Mouse virtual joystick. +x = right (nose right), +y = up (nose up); magnitude ≤ 1. */
export interface Joystick {
  x: number
  y: number
}

export function createJoystick(): Joystick {
  return { x: 0, y: 0 }
}

/** Accumulates mouse movement into the stick, clamped to the unit circle. */
export function applyMouseDelta(j: Joystick, dx: number, dy: number, sensitivity: number, invertY: boolean): void {
  j.x += dx * sensitivity
  j.y += (invertY ? dy : -dy) * sensitivity
  const len = Math.sqrt(j.x * j.x + j.y * j.y)
  if (len > 1) {
    j.x /= len
    j.y /= len
  }
}

/** Exponential return to centre. Rate 0 means the stick stays where you leave it. */
export function recenterJoystick(j: Joystick, rate: number, dt: number): void {
  if (rate <= 0) return
  const k = Math.exp(-rate * dt)
  j.x *= k
  j.y *= k
}

/** Deadzone plus response curve: sign(v)·((|v| − dz) / (1 − dz))^exponent, and 0 inside the deadzone. */
export function axisResponse(v: number, deadzone: number, exponent: number): number {
  const a = Math.abs(v)
  if (a <= deadzone) return 0
  const n = Math.min((a - deadzone) / (1 - deadzone), 1)
  return Math.sign(v) * n ** exponent
}
